import { Provider } from '@angular/core';
import { IFrameTopbarService } from '../iframe/i-frame-topbar.service';
import { MainTopBarService } from '../top-bar/top-bar.service';
import { TopBarService } from '../top-bar/top-bar.service';
import { inIframe } from '@asamco/utils';

/**
 * A provider that provides an implementation of
 * `TopBarService` based on `inIframe`'s return value.
 */
export const topBarServiceProvider: Provider = {
	provide: TopBarService,
	deps: [MainTopBarService, IFrameTopbarService],
	useFactory: (topBarService, iFrameTopbarService) => {
		if (inIframe()) {
			return iFrameTopbarService;
		} else {
			return topBarService;
		}
	},
};
